import styled from 'styled-components';

export { Modal } from '../semcore';
export const ModalWrapper = styled.div`
    max-width: 600px;
`;
